import SeccionMenu from './contenido/index.json';

var submenu_empresa=[];

SeccionMenu.secciones.map((seccion_submenu)=>{
    submenu_empresa.push({titulo:seccion_submenu.titulo,linkto:"/acercaden/"+seccion_submenu.ruta});
    return <></>;
});

const ConfigMenu = {
    "configuracion":{
        "tipo_logo":"1",
        "menu_datos":{
            "activado":"false",
            "menu":"datos",
            "variable":"",
            "contenido":[
                {
                    "titulo":"Telefono",
                    "variable": "telefono"
                },
                {
                    "titulo":"Email",
                    "variable": "email"
                }
            ]
        },
        "menu_blog":{
            "activado":"true"
        },
        "menu_iconos":{
            "activado":"true",
            "menu":"iconos",
            "variable":"",
            "boton_sucursales":{
                "activado":"false"
            },
            "boton_webpay":{
                "activado":"true",
                "texto":"Pago en"
            },
            "contenido":[
                {
                    "titulo":"Whatsapp",
                    "variable": "whatsapp"
                },
                {
                    "titulo":"Facebook",
                    "variable": "facebook"
                },
                {
                    "titulo":"Instagram",
                    "variable": "instagram"
                }
            ]
        }
    },
    "menu_categorias_root":{
        "activado":"false"
    },
    "menu_sucursales":{
        "activado":"true"
    },
    "menu_down":{
        "estructura":[
            {titulo:"Contacto",linkto:"/contacto",tipo:"default"},
            {titulo:"Secciones",linkto:"/blogsec",tipo:"default"},
            {titulo:"Nosotros",linkto:"/acercaden",tipo:"dropdown",
               /*submenu:[
               ]*/
               submenu:submenu_empresa
            },
            {titulo:"Tracking",linkto:"/tracking",tipo:"default"}
        ],
        "menu_categorias":{
            "activado":"true",
            "titulo":"Nuestros Productos"
        },
        "menu_blog":{
            "activado":"false",
            "titulo":"Seccio"
        }
    }
}

export default ConfigMenu;
